import cn from 'classnames'

import './index.css'

export const containerClassName =
   'p-[12px] rounded-[10px] transition-colors duration-200 cursor-pointer flex items-center mb-[4px]'

export const nameAndIconContainerClassName =
   'flex items-center flex-1 truncate mr-[8px]'

export const iconContainerClassName = 'mr-[12px]'

export const imageIconClassName = 'h-[20px] w-[20px]'

export const nameClassName = 'text-sm-medium truncate'

export const childrenContainerClassName = 'flex flex-col flex-grow'

export const chevronIconStyles = (isOpen: boolean) =>
   cn(
      'flex-shrink-0',
      {
         'default-expandable-icon-open': isOpen
      },
      {
         'default-expandable-icon-close': !isOpen
      }
   )
